import { Typography, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { SignupButton } from './common/SignupButton';

const useStyles = makeStyles()((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(3),
    },
  },
  heading: {
    marginBottom: theme.spacing(2),
  },
  subheading: {
    marginBottom: theme.spacing(3),
  },
}));

export const CTA = () => {
  const { classes } = useStyles();
  const isMobile = useIsMobile();

  return (
    <Container
      maxWidth="md"
      className={classes.root}
    >
      <Typography
        variant={isMobile ? 'h4' : 'h2'}
        className={classes.heading}
      >
        Book More Gigs and Get Paid Faster
      </Typography>

      <Typography
        variant={isMobile ? 'subtitle1' : 'h5'}
        className={classes.subheading}
      >
        Find venues, manage gigs, and never pay an upfront fee.
        {isMobile ? ' ' : <br />}
        All on one free platform.
      </Typography>

      <SignupButton
        id="sda-home-cta-signup-button"
      />
    </Container>
  );
};
